export default __webpack_public_path__ + "static/media/1.651fe2fe.png";